import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';

const DeleteChatbotConfigModal = ({ open, onClose, onDelete, config }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      if (onDelete) await onDelete();
      onClose();
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const botName = config?.branding?.bot_name || 'this chatbot';
  const chatSlug = config?.chat_slug || '';
  const plan = config?.plan || '';

  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Confirm Deletion</ModalHeader>
      <ModalBody>
        <p className="mb-0">
          Are you sure you want to delete <strong>{botName}</strong>
          {chatSlug && <> (<code>{chatSlug}</code>)</>}
          {plan && <> — {plan} plan</>}?
          <br />
          <small className="text-muted">
            This action cannot be undone. The embed token will stop working immediately and
            any leads or sessions linked to this config will no longer be accessible.
          </small>
        </p>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button color="danger" onClick={handleConfirm} disabled={loading}>
          {loading && <Spinner size="sm" className="me-2" />}
          {loading ? 'Deleting…' : 'Delete Config'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { DeleteChatbotConfigModal };